import React, { Component } from "react";
export default class Project extends Component {
  render() {
    let item = this.props.item;

    return (
      <section id="project">
        <div className="portfolio-item-meta">
          <img src={`${item.img1url}`} className="img1" />
          {item.img2url && <img src={`${item.img2url}`} className="img2" />}
          <h5>{item.name}</h5>
          <p>{item.description}</p>
          <br />
          {item.github && (
            <>
              <a href={item.github} target="_blank" rel="noopener noreferrer">
                Go to github repository
              </a>
              <br />
            </>
          )}
          {item.report && (
            <>
              <a href={item.report} target="_blank" rel="noopener noreferrer">
                Go to project report
              </a>
              <br />
            </>
          )}
          {item.video && (
            <>
              <a href={item.video} target="_blank" rel="noopener noreferrer">
                Go to video
              </a>
              <br />
            </>
          )}
          {item.website && (
            <>
              <a href={item.website} target="_blank" rel="noopener noreferrer">
                Go to website
              </a>
            </>
          )}
          {item.certificate && (
            <>
              <a
                href={item.certificate}
                target="_blank"
                rel="noopener noreferrer"
              >
                Go to certificate
              </a>
            </>
          )}
        </div>
      </section>
    );
  }
}
